import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

export const translations = {
  az: {
    menu: 'Menyu',
    our_menu: 'Menyumuz',
    products: 'Məhsul',
    search: 'Axtarış...',
    search_placeholder: 'Məhsul axtar...',
    service_fee: 'Servis haqqı',
    language: 'Dil',
    no_results: 'Nəticə tapılmadı',
    back: 'Geri',
    no_items: 'Bu kateqoriyada məhsul yoxdur',
    address: 'Ünvan',
    phone: 'Telefon',
    currency: 'Valyuta',
    discount: 'Endirim',
    featured: 'Seçilmiş',
    login: 'Daxil ol',
    register: 'Qeydiyyat',
    email: 'Email',
    password: 'Şifrə',
    full_name: 'Tam ad',
    welcome: 'Xoş Gəlmisiniz',
    login_subtitle: 'Hesabınıza daxil olun',
    no_account: 'Hesabınız yoxdur?',
    have_account: 'Artıq hesabınız var?',
    logout: 'Çıxış',
    dashboard: 'Əsas Səhifə',
    restaurants: 'Restoranlar',
    add_restaurant: 'Yeni Restoran',
    manage_menu: 'Menyu İdarəsi',
    name: 'Ad',
    description: 'Təsvir',
    price: 'Qiymət',
    image: 'Şəkil',
    add: 'Əlavə et',
    save: 'Yadda saxla',
    cancel: 'İmtina',
    delete: 'Sil',
    edit: 'Dəyişdir',
  },
  en: {
    menu: 'Menu',
    our_menu: 'Our Menu',
    products: 'Products',
    search: 'Search...',
    search_placeholder: 'Search products...',
    service_fee: 'Service fee',
    language: 'Language',
    no_results: 'No results found',
    back: 'Back',
    no_items: 'No items in this category',
    address: 'Address',
    phone: 'Phone',
    currency: 'Currency',
    discount: 'Discount',
    featured: 'Featured',
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    full_name: 'Full Name',
    welcome: 'Welcome',
    login_subtitle: 'Sign in to your account',
    no_account: "Don't have an account?",
    have_account: 'Already have an account?',
    logout: 'Logout',
    dashboard: 'Dashboard',
    restaurants: 'Restaurants',
    add_restaurant: 'New Restaurant',
    manage_menu: 'Manage Menu',
    name: 'Name',
    description: 'Description',
    price: 'Price',
    image: 'Image',
    add: 'Add',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
  },
  ru: {
    menu: 'Меню',
    our_menu: 'Наше меню',
    products: 'Продукты',
    search: 'Поиск...',
    search_placeholder: 'Поиск продуктов...',
    service_fee: 'Сервисный сбор',
    language: 'Язык',
    no_results: 'Ничего не найдено',
    back: 'Назад',
    no_items: 'В этой категории нет товаров',
    address: 'Адрес',
    phone: 'Телефон',
    currency: 'Валюта',
    discount: 'Скидка',
    featured: 'Рекомендуемое',
    login: 'Войти',
    register: 'Регистрация',
    email: 'Email',
    password: 'Пароль',
    full_name: 'Полное имя',
    welcome: 'Добро пожаловать',
    login_subtitle: 'Войдите в свой аккаунт',
    no_account: 'Нет аккаунта?',
    have_account: 'Уже есть аккаунт?',
    logout: 'Выход',
    dashboard: 'Панель',
    restaurants: 'Рестораны',
    add_restaurant: 'Новый ресторан',
    manage_menu: 'Управление меню',
    name: 'Название',
    description: 'Описание',
    price: 'Цена',
    image: 'Изображение',
    add: 'Добавить',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
  },
  tr: {
    menu: 'Menü',
    our_menu: 'Menümüz',
    products: 'Ürünler',
    search: 'Ara...',
    search_placeholder: 'Ürün ara...',
    service_fee: 'Servis ücreti',
    language: 'Dil',
    no_results: 'Sonuç bulunamadı',
    back: 'Geri',
    no_items: 'Bu kategoride ürün yok',
    address: 'Adres',
    phone: 'Telefon',
    currency: 'Para birimi',
    discount: 'İndirim',
    featured: 'Öne çıkan',
    login: 'Giriş yap',
    register: 'Kaydol',
    email: 'E-posta',
    password: 'Şifre',
    full_name: 'Ad Soyad',
    welcome: 'Hoş geldiniz',
    login_subtitle: 'Hesabınıza giriş yapın',
    no_account: 'Hesabınız yok mu?',
    have_account: 'Zaten hesabınız var mı?',
    logout: 'Çıkış',
    dashboard: 'Panel',
    restaurants: 'Restoranlar',
    add_restaurant: 'Yeni Restoran',
    manage_menu: 'Menü Yönetimi',
    name: 'Ad',
    description: 'Açıklama',
    price: 'Fiyat',
    image: 'Görsel',
    add: 'Ekle',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
  },
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage LanguageProvider daxilində istifadə edilməlidir');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('lang') || 'az';
  });

  useEffect(() => {
    localStorage.setItem('lang', lang);
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.az[key] || key;

  const getLocalized = (obj, baseField) => {
    if (!obj) return '';
    const key = `${baseField}_${lang}`;
    return obj[key] || obj[`${baseField}_az`] || obj[baseField] || '';
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, getLocalized }}>
      {children}
    </LanguageContext.Provider>
  );
};
